<template>
  <section class="partialOrder">
    <div class="partial" style="overflow-x: auto">
      <div class="partial__loader" v-if="loader">
        <span><i class="fas fa-stroopwafel fa-spin fa-3x"></i></span>
        <span
          >Aguarde, enquanto os pedidos aprovados parcialmente carregam!</span
        >
      </div>
      <table v-if="!loader">
        <thead>
          <tr>
            <th>Pedido</th>
            <th>Cliente</th>
            <th>Data</th>
            <th>Vendedor</th>
            <th>Parceiro</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(info, i) in parcialmenteAprovado" :key="i">
            <td>
              <router-link
                target="_blank"
                rel="noopener"
                :to="'/panel/orders/DetailsOrder?Pedido=' + info.NrDocumento"
                >{{ info.NrDocumento }}</router-link
              >
            </td>
            <td>{{ info.NomeCliente }}</td>
            <td>{{ moment(info.Data).format("DD/MM/YYYY HH:mm:ss") }}</td>
            <td>{{ info.Vendedor }}</td>
            <td>{{ info.Parceiro }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      token: null,
      parcialmenteAprovado: [],
      loader: false,
    };
  },
  methods: {
    async getDados() {
      try {
        let dados = JSON.parse(localStorage.getItem("login"));

        this.token = dados.token;
        this.loader = true;
        const response = await axios.get(
          `https://www.leverosintegra.com.br/MAP/api/Notification/${this.token}`
        );

        let infos = response.data;
        let parcialmente = [];

        infos.forEach(function (o) {
          if (o.TpNotificacao == "Parcialmente Aprovado") {
            parcialmente = o.notificacao;
          }
        });

        this.parcialmenteAprovado = parcialmente;
        this.loader = false;
      } catch (error) {
        console.log(error);
        this.loader = false;
      }
    },
  },

  beforeMount() {
    this.getDados();
  },
};
</script>

<style lang="scss" scoped>
.partial {
  max-width: 80%;
  margin: 0 auto;
  padding-top: 40px;

  &__loader {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    padding-top: 50px;

    i {
      color: var(--customBlue);
      margin-top: 30px;
    }

    span:nth-child(2) {
      padding-top: 10px;
      font-size: 0.95rem;
    }
  }

  table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;

    thead {
      tr {
        th {
          background: var(--customGray-70);
          padding: 10px;
          color: var(--customGray-500);
          font-size: 0.95rem;
        }
      }
    }

    tbody {
      tr {
        &:nth-child(even) {
          background: var(--customGray-70);
        }

        td {
          text-align: center;
          padding: 15px;
          border-bottom: 1px solid var(--customGray-100);
          font-size: 0.95rem;

          a {
            color: var(--standardGreen);
            font-weight: bold;
          }

          button {
            background: var(--customLightGreen);
            padding: 5px;
            border-radius: 5px;
            outline: none;
          }
        }
      }
    }
  }
}

::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: var(--customGray-500);
}

::-webkit-scrollbar {
  height: 8px;
  background: var(--customGray-200);
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  background-color: var(--customLightGreen);
  border-radius: 10px;
}
</style>